import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import './styles.scss';

import mouseIcon from '../../assets/images/landing/icon_mouse.svg';
import subscribeIcon from '../../assets/images/subscribed_message.svg';

import NavBar from './navbar';
import Footer from '../../components/footer';

import * as NewsletterService from '../../services/Newsletter';
import * as AnalyticsService from '../../services/Analytics';

import * as Utils from '../../utils/global';
import { ModalContext } from '../../context/modal';

const Home = ({
  isLoggedIn,
  user,
}: {
  isLoggedIn: boolean,
  user?: any,
}) => {
  const history = useHistory();
  const { t } = useTranslation();

  const [email, setEmail] = useState<string>();
  const [phoneNumber, setPhoneNumber] = useState<string>();
  const [subscribed, setSubscribed] = useState<boolean>(false);

  const handleSendSubscription = () => {
    setSubscribed(true);
    NewsletterService.addSubscription({email, phoneNumber})
  };

  const resetSubscriptionForm = () => {
    setEmail('');
    setPhoneNumber('');
    setSubscribed(false);
  };

  const s3Bucket = 'https://campomercadobucket.s3.sa-east-1.amazonaws.com';
  // resources
  const benefitsProtection = s3Bucket + '/assets/landing/benefits/benefits-protection.png';
  const benefitsNational = s3Bucket + '/assets/landing/benefits/benefits-national.svg';
  const benefits3 = s3Bucket + '/assets/landing/benefits/benefits-3.svg';
  const benefits4 = s3Bucket + '/assets/landing/benefits/benefits-4.svg';

  const video = s3Bucket + '/assets/landing/how-work/video.svg';
  const insertLot = s3Bucket + '/assets/landing/how-work/insert-lot.svg';
  const notification = s3Bucket + '/assets/landing/how-work/notification.svg';

  const speak = s3Bucket + '/assets/landing/help-you/speak-with-us.svg';
  const tips = s3Bucket + '/assets/landing/help-you/tips.svg';
  const information = s3Bucket + '/assets/landing/help-you/information.svg';
  const advice = s3Bucket + '/assets/landing/help-you/get-advice.svg';

  const testimonial3 = s3Bucket + '/assets/landing/testimonials/carlos_fuellis.jpeg';
  const testimonial1 = s3Bucket + '/assets/landing/testimonials/pablo_carrau.jpg';
  const testimonial2 = s3Bucket + '/assets/landing/testimonials/marcos_miller.jpeg';

  const {
    setOpen: modalSetOpen,
    setLoginOpen: loginModalSetOpen,
  } = useContext(ModalContext);

  const invalidateEmail = () => {
    if (Utils.emailValid(email)) {
      return false;
    }
    return true;
  }

  const goToStart = () => {
    AnalyticsService.sendFacebookInformation();
    // history.push('/venta');
    if (isLoggedIn) {
      modalSetOpen(true);
    } else {
      loginModalSetOpen(true);
    }
  }

  return (
    <>
      <NavBar isLoggedIn={isLoggedIn} />
      <section className="start cover">
        <div className="container">
          <div className="row">
            <div className="data">
              <h1>{t('landing:start.title')}</h1>
              <p>{t('landing:start.detail')}</p>
              <div>
                <button className="btn-primary" id="start-button" onClick={() => goToStart()}>{t('landing:buttons.empezar')}</button>
              </div>
            </div>
            <div className="instructions">
              <img src={mouseIcon} /><p>{t('landing:start.instructions')}</p>
            </div>
          </div>
        </div>
      </section>
      <section className="benefits">
        <div className="benefits">
          <h2>{t('landing:benefits.title')}</h2>
          <div className="benefits-row">
            <div className="each">
              <img src={benefitsProtection} alt="sleep"/>
              <div className="data">
                <h3>{t('landing:benefits.list.sleep.title')}</h3>
                <p>{t('landing:benefits.list.sleep.text')}</p>
              </div>
            </div>
            <div className="each">
              <img src={benefitsNational} alt=""/>
              <div className="data">
                <h3>{t('landing:benefits.list.national.title')}</h3>
                <p>{t('landing:benefits.list.national.text')}</p>
              </div>
            </div>
            <div className="each">
              <img src={benefits3} alt=""/>
              <div className="data">
                <h3>{t('landing:benefits.list.benefits3.title')}</h3>
                <p>{t('landing:benefits.list.benefits3.text')}</p>
              </div>
            </div>
            <div className="each">
              <img src={benefits4} alt=""/>
              <div className="data">
                <h3>{t('landing:benefits.list.benefits4.title')}</h3>
                <p>{t('landing:benefits.list.benefits4.text')}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="how-works">
          <h4>{t('landing:how-works.title')}</h4>
          <div className="container">
            <div className="how-works-row">
              <div className="work">
                <div className="number">1</div>
                <div className="description">
                  <img src={video} alt="video"/>
                  <h5>{t('landing:how-works.list.video.title')}</h5>
                  <p>{t('landing:how-works.list.video.text')}</p>
                </div>
              </div>
              <div className="work">
                <div className="number">2</div>
                <div className="description">
                  <img src={insertLot} alt="lot"/>
                  <h5>{t('landing:how-works.list.lot.title')}</h5>
                  <p>{t('landing:how-works.list.lot.text')}</p>
                </div>
              </div>
              <div className="work">
                <div className="number">3</div>
                <div className="description">
                  <img src={notification} alt="notification"/>
                  <h5>{t('landing:how-works.list.order.title')}</h5>
                  <p>{t('landing:how-works.list.order.text')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="are-ready cover">
        <div className="container">
          <div className="row">
            <div className="data">
              <h2>{t('landing:are-ready.title')}</h2>
              <p>{t('landing:are-ready.detail')}</p>
              <div>
                <button className="btn-primary" onClick={() => goToStart()}>{t('landing:buttons.empezar')}</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="testimonials-and-help-you">
        <h4>{t('landing:testimonials.title')}</h4>
        <div className="testimonials">
          <div className="testimonials-row">
            <div className="each">
              <div className="semi">“</div>
              <p>{t('landing:testimonials.list.first.text')}</p>
              <div className="data">
                <img src={testimonial3} alt=""/>
                <div className="profile">
                  <h5>{t('landing:testimonials.list.first.author')}</h5>
                  <h6>{t('landing:testimonials.list.first.location')}</h6>
                </div>
              </div>
            </div>
            <div className="each">
              <div className="semi">“</div>
              <p>{t('landing:testimonials.list.second.text')}</p>
              <div className="data">
                <img src={testimonial1} alt=""/>
                <div className="profile">
                <h5>{t('landing:testimonials.list.second.author')}</h5>
                <h6>{t('landing:testimonials.list.second.location')}</h6>
                </div>
              </div>
            </div>
            <div className="each">
              <div className="semi">“</div>
              <p>{t('landing:testimonials.list.third.text')}</p>
              <div className="data">
                <img src={testimonial2} alt=""/>
                <div className="profile">
                <h5>{t('landing:testimonials.list.third.author')}</h5>
                  <h6>{t('landing:testimonials.list.third.location')}</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="help-you">
          <h4>{t('landing:help.title')}</h4>
          <div className="container">
            <div className="row">
              <div className="each">
                <img src={speak} alt="speak" />
                <div className="data">
                  <h3>{t('landing:help.list.first.title')}</h3>
                  <p>{t('landing:help.list.first.text')}</p>
                </div>
              </div>
              <div className="each">
                <img src={tips} alt="" />
                <div className="data">
                  <h3>{t('landing:help.list.second.title')}</h3>
                  <p>{t('landing:help.list.second.text')}</p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="each">
                <img src={information} alt="information" />
                <div className="data">
                  <h3>{t('landing:help.list.third.title')}</h3>
                  <p>{t('landing:help.list.third.text')}</p>
                </div>
              </div>
              <div className="each">
                <img src={advice} alt="advice" />
                <div className="data">
                  <h3>{t('landing:help.list.fourth.title')}</h3>
                  <p>{t('landing:help.list.fourth.text')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="join-us cover">
        <div className="container">
          <div className="row">
            <div className="data">
              <h2>{t('landing:join-us.title')}</h2>
              <p>
                {t('landing:join-us.text')}
              </p>
              <div>
                <button className="btn-primary" onClick={() => goToStart()}>{t('landing:buttons.empezar')}</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="notification">
        <div className="container">
          <div className="row">
            <div className="info">
              <span>{t('landing:notifications.title')}</span>
              <p>{t('landing:notifications.text')}</p>
            </div>
            <div className="subscribe">
              {!subscribed ? (
                <form onSubmit={handleSendSubscription}>
                  <div className="row">
                    <input
                      type="email"
                      value={email}
                      onChange={(e: any) => setEmail(e.target.value)}
                      name="email"
                      className="form-control"
                      placeholder="Correo electrónico"
                      required
                    />
                    <input
                      type="text"
                      value={phoneNumber}
                      onChange={(e: any) => setPhoneNumber(e.target.value)}
                      name="phone"
                      className="form-control phone"
                      placeholder="Teléfono (Opcional)"
                    />
                  </div>
                  <div className="row">
                    <button type="submit" className="btn-secondary" disabled={invalidateEmail()}>{t('landing:buttons.subscribe')}</button>
                  </div>
                </form>
              ) : (
                <div className="subscribe">
                  <div className="row">
                    <img src={subscribeIcon} alt="subscribe" />
                    <p><b>¡Gracias!</b> El próximo lunes empezarás a recibir tu boletín en tu correo electrónico.</p>
                  </div>
                  <div className="row">
                    <button className="btn btn-link link" onClick={resetSubscriptionForm}>Ingresar otro correo electrónico</button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="container">
          <h4>{t('landing:faq.title')}</h4>
          <div className="row">
            <div className="question">
              <h6>{t('landing:faq.list.q1.q')}</h6>
              <p>{t('landing:faq.list.q1.a')}</p>
            </div>
            <div className="question">
              <h6>{t('landing:faq.list.q2.q')}</h6>
              <p>{t('landing:faq.list.q2.a')}</p>
            </div>
            <div className="question">
              <h6>{t('landing:faq.list.q3.q')}</h6>
              <p>{t('landing:faq.list.q3.a')}</p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  )
};

export default Home;
